<template>
  <div class="d-none d-print-block">
    <div>{{ horse.name }}</div>
    <div>
      {{
        $t(
          "horses:horseProfilePage.FEIlicence.field.label",
          "FEI licence:",
          "FEI licence field label on horse profile"
        )
      }}: {{ horse.feiid }}
    </div>
    <div>
      {{ $t("horses:horseProfilePage.ueln.field.label", "UELN:") }}
      {{ horse.ueln }}
    </div>
    <div>
      {{
        $t(
          "horses:horseProfilePage.Birthdate.field.label",
          "Birth date:",
          "Birth date field label on horse profile"
        )
      }}
      {{ $dayjs.date(horse.dateOfBirth) }}
    </div>
    <div>
      {{ $t("horses:horseProfilePage.chipNumber.field.label", "Chip:") }}
      {{ horse.chipNumber }}
    </div>
    <div v-if="horse.breedingStudbookId">
      {{
        $t(
          "horses:horseProfilePage.breed.field.label",
          "Breed:",
          "Breed field label on horse profile"
        )
      }}
      {{ horse.breedingStudbook.name }}
    </div>

    <br />
  </div>
</template>
<script>
export default {
  name: "AppPrintBasicHorseDetails"
};
</script>
<script setup>
defineProps({
  horse: {
    type: Object,
    required: true
  }
});
</script>
